import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_7 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;

  return (
    <>
      <g>
        <path
          fill={primary}
          d="M281.7,215c-6-2.1-11.6-1.6-21.2,0.4c0,0,13.4-15.6,29.2-13.8c3.1,0.4,25.5,6.9,27.7,9.1
		c3,2.9-22.4,19.8-22,23.9C292.5,228.8,287.9,217.1,281.7,215z"
        />
        <path
          fill={primary}
          d="M286.9,181.9c0,0-0.5,21.2,13.7,24l8.6-11.8C309.3,194,290.7,192.4,286.9,181.9z"
        />
        <path
          fill={primary}
          d="M283.7,413.2l0.1-0.4c3.2-9.7,5-19.9,5.2-30.2c0.4-18,0.6-35.3,0.7-39.9c0.1-11.2,5.6-75.1,29.8-76.5
		c5.6-0.3,20.5,17.4,40.3,25.6c3.5,1.5,33.7-17.9,49.4-23.4c46.7-16.4,89.6,28.2,89.6,28.2c13.6,15.1,14.6,39,14.7,46.1
		c0,4.7,0.2,22,0.7,40c0.2,10.3,2.1,20.6,5.4,30.4l0.1,0.1c2.3-11,9-40.9,14.6-61.8c9.4-34.8,12.7-64.6,11-72.4l-24.9-45.4
		c-33.8-61.7-113.3-80.9-171.5-41.5l-21.8,14.8c-30.5-10.7-37.7,4.4-46.2,15.7c-15.8,21-21.8,53.8-22.4,83.4
		c-0.2,11,3,20.8,11.4,52.5C275.2,378.5,281.6,403.1,283.7,413.2z"
        />
        <path
          fill={secondary}
          d="M597.4,231.3c-20.1,38.6-55.7,7-68.8-21.4c-32.4-70-71.4-59.1-71.4-59.1c-79.9-61.9-100.9,0.7-100.9,0.7
		c-62.5-6.2-64.9,28.8-55.4,59.9c9.4,30.9,31.1,56.6,58.8,73.1c1.2,0.7,2.5,1.5,3.7,2.2c20.6-33.8,58.9-36.7,75.8-34.5
		c22.7,2.9,31.6,15,46.3,27.2c22.6,18.8,32.7,27.3,75.5,23.3C629.7,296.3,597.4,231.3,597.4,231.3z"
        />
        <path
          fill={primary}
          d="M597.4,231.3c-20.1,38.6-55.7,7-68.8-21.4c-32.4-70-71.4-59.1-71.4-59.1c-79.9-61.9-100.9,0.7-100.9,0.7
		c-62.5-6.2-64.9,28.8-55.4,59.9c9.4,30.9,31.1,56.6,58.8,73.1c1.2,0.7,2.5,1.5,3.7,2.2c15.3-40.6,55.5-44.3,72.4-45.7
		c10.2-0.8,28.6,1,42.8,12.1c38.6,30,39.5,53.5,82.4,49.5C629.7,296.3,597.4,231.3,597.4,231.3z"
        />
        <path
          fill={secondary}
          d="M597.4,231.3c-20.1,38.6-55.7,7-68.8-21.4c-32.4-70-71.4-59.1-71.4-59.1c-79.9-61.9-100.9,0.7-100.9,0.7
		c-62.5-6.2-64.9,28.8-55.4,59.9c9.4,30.9,31.1,56.6,58.8,73.1c1.2,0.7,2.5,1.5,3.7,2.2c15.3-40.6,52.8-72.2,69.8-73.5
		c10.2-0.8,28.6,1,42.8,12.1c38.6,30,42.2,81.3,85.1,77.4C629.7,296.3,597.4,231.3,597.4,231.3z"
        />
        <path
          fill={primary}
          d="M359.8,284.6c0,0-46.1-167,41.6-161.1c0,0,30.2,2.9,55.8,27.3c0,0-57.2-20.3-76.6,9
		C356.2,196.5,354.5,243.9,359.8,284.6z"
        />
        <path
          fill={primary}
          d="M505.8,191.4c0,0-17.7-21.9-54.9-23.5c-35.9-1.5-85.1,14.7-91.1,116.7c0,0,25.8-92.7,94.3-105.7
		C464.5,176.9,479.1,177.6,505.8,191.4z"
        />
        <path
          fill={primary}
          d="M324.2,172.1c-5.3,8.9-2.3,22,6.7,27.1c-4.1-10.3-4.7-21.9-1.9-32.7C327.1,168.1,325.5,170,324.2,172.1z"
        />
        <path
          fill={primary}
          d="M334.5,231.6c-0.8-1.8-1.7-3.7-3.1-5c-2.4-2.1-6.1-2.3-8.7-4.1c4.5,4.5,6,11.1,8.2,17.1
		c2.2,6,6.1,12.2,12.3,13.5C340.6,245.8,337.7,238.6,334.5,231.6z"
        />
        <path
          fill={primary}
          d="M560.1,271.6c-16.3-2-31.5-11.9-39.8-26.1c0.4,1.3,0.8,2.6,1.2,3.9c1.9,6.1,3.9,12.2,7.3,17.6
		c3.4,5.4,8.5,9.9,14.8,11.3C549.9,279.7,557.1,277.2,560.1,271.6z"
        />
        <path
          fill={primary}
          d="M494.4,220.1c-7.2-12.7-21.4-21.1-36-21.4c8.2-2.1,17.3-2.2,24.7,1.9c7.4,4,12.6,12.9,10.6,21.1
		C494.2,222.4,494.9,220.9,494.4,220.1z"
        />
      </g>
    </>
  );
};

export default Hair_7;
